'use client';

import React from 'react';
import { Avatar, AvatarFallback, AvatarImage } from '../ui/avatar';
import { cn } from '../../../lib/utils';

/**
 * KeenAI-Style Chat Message Component
 * Exact recreation: Blue bubbles for user, Gray bubbles for AI
 */
export function KeenAIChatMessage({
  message,
  sender,
  timestamp,
  avatar,
  isTyping = false
}) {
  const isUser = sender === 'user';
  const isAI = sender === 'alice' || sender === 'ai';

  // Typing indicator
  if (isTyping) {
    return (
      <div className="flex gap-3 items-start mb-4">
        <Avatar className="w-8 h-8 shrink-0">
          <AvatarImage src="/hero-character.jpeg" alt="ALICE" />
          <AvatarFallback className="bg-gradient-to-br from-purple-500 to-orange-500 text-white text-xs">
            AI
          </AvatarFallback>
        </Avatar>
        <div className="flex-1">
          <div className="bg-orange-100 rounded-2xl rounded-tl-none px-4 py-3 max-w-md border border-orange-200">
            <div className="flex space-x-1">
              <div className="w-2 h-2 bg-orange-400 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
              <div className="w-2 h-2 bg-orange-400 rounded-full animate-bounce" style={{ animationDelay: '200ms' }}></div>
              <div className="w-2 h-2 bg-orange-400 rounded-full animate-bounce" style={{ animationDelay: '400ms' }}></div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // User message (right side, light blue bubble)
  if (isUser) {
    return (
      <div className="flex gap-3 items-start mb-6 justify-end">
        <div className="flex-1 flex flex-col items-end max-w-[75%]">
          <div className="bg-blue-100 text-gray-900 rounded-2xl rounded-tr-none px-4 py-3 border border-blue-200">
            <p className="text-sm leading-relaxed whitespace-pre-wrap">{message}</p>
          </div>
          {timestamp && (
            <span className="text-xs text-gray-500 mt-1.5 mr-1">{timestamp}</span>
          )}
        </div>
        <Avatar className="w-8 h-8 shrink-0">
          <AvatarImage src={avatar} alt="User" />
          <AvatarFallback className="bg-blue-100 text-gray-900 text-xs border border-blue-200">
            {avatar ? '' : 'U'}
          </AvatarFallback>
        </Avatar>
      </div>
    );
  }

  // AI message (left side, light orange bubble)
  return (
    <div className="flex gap-3 items-start mb-6">
      <Avatar className="w-8 h-8 shrink-0">
        <AvatarImage src="/hero-character.jpeg" alt="ALICE" />
        <AvatarFallback className="bg-gradient-to-br from-purple-500 to-orange-500 text-white text-xs">
          AI
        </AvatarFallback>
      </Avatar>
      <div className="flex-1 flex flex-col max-w-[75%]">
        <div className="bg-orange-100 rounded-2xl rounded-tl-none px-4 py-3 border border-orange-200">
          <p className="text-sm text-gray-900 leading-relaxed whitespace-pre-wrap">{message}</p>
        </div>
        {timestamp && (
          <span className="text-xs text-gray-500 mt-1.5 ml-1">{timestamp}</span>
        )}
      </div>
    </div>
  );
}

export default KeenAIChatMessage;

